(ns rothko.theme.manatee.form2.select.single-select
  (:refer-clojure :exclude [rem +])
  (:require [garden.arithmetic :refer [+]]
            [garden.units :refer [rem px]]
            [garden.color :refer [lighten]]
            [rothko.theme.manatee.colours :refer [colours]]
            [rothko.theme.manatee.form.input :as input-theme]
            [rothko.theme.manatee.form2.validation-message
             :as validation-message-theme]))

(def options-padding (rem 1))

(defn common-class-styles
  [width opts-padding input-padding]
  {:width width
   :input-width width
   :options-width width
   :options-padding opts-padding
   :input-padding input-padding
   :options-position :absolute
   :options-box-shadow "rgba(0,0,0,0.1) 0px 0px 10px 3px"
   :options-background-color :white
   :selected-background-color (lighten (:blue-light colours) 30)})

(def select
  {:primary (common-class-styles (rem 30) options-padding (rem 1))

   :narrow (common-class-styles (rem 7) options-padding (rem 0.4))

   :text-align-centre {:input-text-align :center}

   :open-above
   {:options-bottom (+ input-theme/total-height
                       options-padding
                       validation-message-theme/messages-min-height)
    :position :relative}

   :open-below
   {:position :initial}})
